import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d2c2219&"
import script from "./createNews.js?vue&type=script&lang=js&"
export * from "./createNews.js?vue&type=script&lang=js&"
import style0 from "./createNews.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports